var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.301 40.8011C31.5129 40.8011 40.602 31.712 40.602 20.5001C40.602 9.28816 31.5129 0.199097 20.301 0.199097C9.08907 0.199097 0 9.28816 0 20.5001C0 31.712 9.08907 40.8011 20.301 40.8011Z",
    fill: "#427168"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8131 30.673L8.68005 22.539C8.56376 22.4229 8.47151 22.2849 8.40857 22.133C8.34563 21.9812 8.31323 21.8184 8.31323 21.654C8.31323 21.4897 8.34563 21.3269 8.40857 21.175C8.47151 21.0232 8.56376 20.8852 8.68005 20.769L10.4501 18.999C10.5662 18.8828 10.7042 18.7905 10.856 18.7276C11.0079 18.6646 11.1707 18.6322 11.3351 18.6322C11.4994 18.6322 11.6622 18.6646 11.8141 18.7276C11.9659 18.7905 12.1039 18.8828 12.2201 18.999L17.6981 24.479L29.4351 12.743C29.5512 12.6268 29.6892 12.5345 29.841 12.4716C29.9929 12.4086 30.1557 12.3762 30.3201 12.3762C30.4844 12.3762 30.6472 12.4086 30.7991 12.4716C30.9509 12.5345 31.0889 12.6268 31.2051 12.743L32.9751 14.513C33.0913 14.6292 33.1836 14.7672 33.2465 14.919C33.3095 15.0709 33.3419 15.2337 33.3419 15.398C33.3419 15.5624 33.3095 15.7252 33.2465 15.877C33.1836 16.0289 33.0913 16.1669 32.9751 16.283L18.5831 30.673C18.4669 30.7893 18.3289 30.8816 18.1771 30.9445C18.0252 31.0075 17.8624 31.0399 17.6981 31.0399C17.5337 31.0399 17.3709 31.0075 17.219 30.9445C17.0672 30.8816 16.9292 30.7893 16.8131 30.673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkChecked);
export default __webpack_public_path__ + "static/media/checkmark_checked.114f5e621d2a4ba186778ad1aa559125.svg";
export { ForwardRef as ReactComponent };